import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import IconButton from "@mui/material/IconButton";
import { PhotoCamera } from "@mui/icons-material";
import CardMedia from "@mui/material/CardMedia";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

function ImageField({ field, onHandleChange = () => {} }) {
    const [title, setTitle] = useState("");
    const [url, setUrl] = useState("");
    const ref = useRef(null);

    useEffect(() => {
        if (field.value) {
            setUrl(field.value.url);
            setTitle(field.value.file_name);
            onHandleChange(field.value);
        }
    }, []);

    const handleChange = (value) => {
        onHandleChange(value);

        if (value.length) {
            setTitle(value[0].name);
            setUrl(URL.createObjectURL(value[0]));
        }
    };

    const removeImg = () => {
        handleChange([]);
        setTitle("");
        setUrl(null);
        ref.current.value = "";
    };

    return (
        <div className="image-field">
            {!!url && (
                <div className="image-field__preview">
                    <CardMedia component="img" sx={{ maxWidth: "100%", width: "auto" }} image={url} />
                    <HighlightOffRoundedIcon onClick={() => removeImg()} />
                </div>
            )}
            <div>{title}</div>
            <label htmlFor={"icon-button-photo-" + field.id}>
                <IconButton color="primary" component="span">
                    <PhotoCamera />
                </IconButton>
            </label>
            <input
                ref={ref}
                hidden={true}
                accept="image/*"
                id={"icon-button-photo-" + field.id}
                onChange={(e) => handleChange(e?.target?.files)}
                type="file"
            />
        </div>
    );
}

export default ImageField;
